import {
  CarrierKind,
  ParamsRedirectToHold,
  ResponseRedirectToHoldLocations,
  ResponseRedirectToHoldLocationsV,
  RequestRedirectToHoldLocations,
} from '../../../server/api/schema';

import { decode } from '../../../server/lib/codec';

export interface LocationsParams {
  carrier: CarrierKind;
  trackingNumber: ParamsRedirectToHold['trackingNumber'];
  request: RequestRedirectToHoldLocations;
}

const getLocations = async ({
  carrier,
  trackingNumber,
  request,
}: LocationsParams): Promise<ResponseRedirectToHoldLocations> => {
  const url = `/api/v1/delivery-management/${carrier}/redirect-to-hold/${trackingNumber}/locations`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return decode(ResponseRedirectToHoldLocationsV, await response.json());
};

export default getLocations;
